// components
import { TextButton } from 'components';

// libraries
import styled from 'styled-components';

export const StyledSystem = styled.div`
  height: 90%;

  .system-wrapper {
    padding-top: 45px;
    display: flex;
    width: 100%;
    gap: 20px;
    height: 100%;

    > div {
      min-width: 40%;
      flex: 1;

      .MuiPaper-root {
        max-height: 100% !important;
        box-shadow: none !important;
      }
    }
  }
`;

export const StyledAddButton = styled(TextButton)`
  height: 32px !important;
`;

export const StyledIconButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  position: relative;

  > button {
    width: 32px !important;
    min-width: 32px !important;
    height: 32px !important;
    border-radius: 4px;
    border: 0.5px solid var(--color-pale-gray);
    background: var(--color-off-white);
    box-shadow: none !important;
    padding: 4px !important;
  }
`;
